module.exports = __webpack_public_path__ + "img/tertiary_10x2.fc83095e.svg";